/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceQuoteDetailsResource } from './';
import {
    FixedPriceQuoteDetailsResourceFromJSON,
    FixedPriceQuoteDetailsResourceFromJSONTyped,
    FixedPriceQuoteDetailsResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { QuoteClientTermsResource } from './';
import {
    QuoteClientTermsResourceFromJSON,
    QuoteClientTermsResourceFromJSONTyped,
    QuoteClientTermsResourceToJSON,
} from './';
import type { QuoteProjectTermsResource } from './';
import {
    QuoteProjectTermsResourceFromJSON,
    QuoteProjectTermsResourceFromJSONTyped,
    QuoteProjectTermsResourceToJSON,
} from './';
import type { QuoteResource } from './';
import {
    QuoteResourceFromJSON,
    QuoteResourceFromJSONTyped,
    QuoteResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteResource
 */
export interface FixedPriceQuoteResource extends QuoteResource {
    /**
     * 
     * @type {FixedPriceQuoteDetailsResource}
     * @memberof FixedPriceQuoteResource
     */
    details: FixedPriceQuoteDetailsResource;
}

/**
 * Check if a given object implements the FixedPriceQuoteResource interface.
 */
export function instanceOfFixedPriceQuoteResource(value: object): value is FixedPriceQuoteResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteResourceFromJSON(json: any): FixedPriceQuoteResource {
    return FixedPriceQuoteResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': FixedPriceQuoteDetailsResourceFromJSON(json['details']),
    };
}

export function FixedPriceQuoteResourceToJSON(value?: FixedPriceQuoteResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteResourceToJSON(value, true),
        'details': FixedPriceQuoteDetailsResourceToJSON(value['details']),
    };
}

